/**
 * stopExpectedDateから各種類の終了日を抽出して表示用の文字列を返す関数
 */
export const extractStopDates = (
  stopExpectedDate: string | null | undefined
): {
  salesStopExpirationDate: string | null;
  salesStopDate: string | null;
  expirationDate: string | null;
  productionStopDate: string | null;
} => {
  // 明示的に型を指定して宣言
  const result: {
    salesStopExpirationDate: string | null;
    salesStopDate: string | null;
    expirationDate: string | null;
    productionStopDate: string | null;
  } = {
    salesStopExpirationDate: null,
    salesStopDate: null,
    expirationDate: null,
    productionStopDate: null,
  };

  if (!stopExpectedDate) return result;

  // 改行コードを統一
  const normalized = stopExpectedDate.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  // 行に分割
  const lines = normalized.split('\n');

  // 1行目: 販売終了日(経過措置)
  if (lines.length >= 1) {
    const dateMatch = lines[0].match(/(\d{4,8})/);
    if (dateMatch) {
      // 明示的に型変換
      result.salesStopExpirationDate = dateMatch[1] as string;
    }
  }

  // 2行目: 販売終了日(販売中止)
  if (lines.length >= 2) {
    const dateMatch = lines[1].match(/(\d{4,8})/);
    if (dateMatch) {
      // 明示的に型変換
      result.salesStopDate = dateMatch[1] as string;
    }
  }

  // 4行目: 経過措置年月日
  if (lines.length >= 4) {
    const dateMatch = lines[3].match(/(\d{4,8})/);
    if (dateMatch) {
      // 明示的に型変換
      result.expirationDate = dateMatch[1] as string;
    }
  }

  // 5行目: 販売中止年月日
  if (lines.length >= 5) {
    const dateMatch = lines[4].match(/(\d{4,8})/);
    if (dateMatch) {
      // 明示的に型変換
      result.productionStopDate = dateMatch[1] as string;
    }
  }

  return result;
};
